import React from 'react';

const ListingFilters = ({ filters = [], selectedFilter = null, onChange, label = 'Display', canSelectAll = true, labelAll='all' }) => {
  function handleChange(evt) {
    const filter = evt.target.value;
    onChange(filter);
  }
  return (
    <div className="form-group quick-filter">
      <label htmlFor="select-filter">{ label }</label>&nbsp;
      <select id="select-filter" className="form-control" value={ selectedFilter } onChange={ handleChange }>
        {
          canSelectAll
            ? <option value="all">{ labelAll }</option>
            : null
        }
        {
          filters.map((filter, i) => {
            return <option key={ i } value={ filter.value }>{ filter.label || filter.value }</option>;
          })
        }
      </select>
    </div>
  );
};

export default ListingFilters;



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ListingFilters.jsx